import { HeroMetrics, Period } from '../../services/penetrationReportV2/types';
import { formatPeriod } from '../../services/penetrationReportV2/periodUtils';

interface HeroCardProps {
  metrics: HeroMetrics;
  comparisonEnabled: boolean;
  comparePeriod: Period;
}

function HeroCard({ metrics, comparisonEnabled, comparePeriod }: HeroCardProps) {
  const { currentPct, priorPct, deltaPct, acquiredCount, targetCount, remainingCount, longTermTargetPct } = metrics;
  const progressToTargetPct = longTermTargetPct > 0 ? Math.min(100, (currentPct / longTermTargetPct) * 100) : 0;
  const priorAcquiredCount = targetCount > 0 ? Math.round((priorPct / 100) * targetCount) : 0;
  const acquiredDelta = acquiredCount - priorAcquiredCount;
  const remainingDelta = -acquiredDelta;

  return (
    <div className="pr2-summary">
      <div className="pr2-labelrow">
        <span className="pr2-section-label">Total market penetration</span>
        {comparisonEnabled && (
          <span className="pr2-pill">{deltaPct >= 0 ? '↑' : '↓'} {Math.abs(deltaPct).toFixed(1)} pp</span>
        )}
      </div>
      <div className="pr2-big">{currentPct.toFixed(1)}<span>%</span></div>
      <p><strong>{acquiredCount.toLocaleString()}</strong> of {targetCount.toLocaleString()} target locations acquired</p>

      {comparisonEnabled && (
        <div className="pr2-previous">
          <span>{formatPeriod(comparePeriod)}</span>
          <strong>{priorPct.toFixed(1)}%</strong>
          <small>{priorAcquiredCount.toLocaleString()} acquired</small>
        </div>
      )}

      <div className="pr2-target">
        <span>Progress to {longTermTargetPct}% long-term target</span>
        <strong>{progressToTargetPct.toFixed(0)}%</strong>
      </div>
      <div className="pr2-progress"><i style={{ width: `${progressToTargetPct}%` }} /></div>

      <div className="pr2-split">
        <div>
          <small>Acquired</small>
          <strong>{acquiredCount.toLocaleString()}</strong>
          {comparisonEnabled && (
            <em>{acquiredDelta >= 0 ? '+' : ''}{acquiredDelta.toLocaleString()} locations</em>
          )}
        </div>
        <div>
          <small>Remaining</small>
          <strong>{remainingCount.toLocaleString()}</strong>
          {comparisonEnabled && (
            <em>{remainingDelta >= 0 ? '+' : ''}{remainingDelta.toLocaleString()} locations</em>
          )}
        </div>
      </div>
    </div>
  );
}

export default HeroCard;
